const headRowsEquip = {
  name: 'Equipment Type',
  equipmentGroup: 'Group',
  checklist: 'Checklist',
}

export default headRowsEquip;
